import Image, { ImageProps } from 'next/image'

import { Button } from '@/shared/ui'

import cl from './FooterBanner.module.scss'

export interface FooterBannerProps {
	title: string
	list: string[]
	buttonLabel: string
	onClick?: () => void
	image: ImageProps
}

export const FooterBanner = ({ title, onClick, list, buttonLabel, image }: FooterBannerProps) => {
	return (
		<a href={'https://www.sberbank.com/ru/person/credits/money/pos'} className={cl.link} target={'_blank'}>
			<div className={cl.main}>
				<div className={cl.wrapper}>
					<div className={cl.listWrapper}>
						<h2 className={cl.title}>{title}</h2>
						<ul className={cl.list}>
							{list &&
								list.map((item, index) => (
									<li className={cl.item} key={index}>
										<p className={cl.itemText}>{item}</p>
									</li>
								))}
						</ul>
					</div>
					<Button className={cl.btn} onClick={onClick} size={'M'}>
						{buttonLabel}
					</Button>
				</div>
				<div className={cl.imgWrapper}>
					<Image
						{...image}
						className={cl.img}
						alt={'Изображение с картой Сбербанк'}
						quality={100}
						style={{ objectFit: 'contain' }}
						priority
					/>
				</div>
			</div>
		</a>
	)
}
